import lodash from 'lodash'
import importer from 'common/importer'
const { arrayFilter } = importer('Helpers/sort', null)

export const getDebitAmount = debitAccount => {
  const amount = debitAccount?.data?.balance?.balanceAvailable
  if (amount) return amount.toFixed(2)
  else return ' -.- '
}
export const getCardLastFour = debitAccount => {
  const cardNumber = debitAccount?.data?.card?.cardNumber
  if (cardNumber) return cardNumber.slice(-4)
  else return '0000'
}
export const getDateMin = debitAccount => {
  const list = debitAccount?.data?.journal
  let min = new Date()
  if (list && list.length) {
    for (let index = 0; index < list.length; index++) {
      const element = list[index]
      var d = new Date(element.transactionDate)
      if (d < min) min = d
      if (index >= list.length - 1) return min
    }
  } else return min
}
export const getDateMax = debitAccount => {
  const list = debitAccount?.data?.journal
  let max = new Date()
  if (list && list.length) {
    for (let index = 0; index < list.length; index++) {
      const element = list[index]
      var d = new Date(element.transactionDate)
      if (d > max) max = d
      if (index >= list.length - 1) return max
    }
  } else return max
}
/**
 * @param {Object} newState
 * @param {Object} curState
 * @param {Function} setState
 */
export const setHistory = (newState, curState, setState) => {
  return JSON.stringify(curState) !== JSON.stringify(newState)
    ? setState(newState)
    : null
}
/**
 * THIS FUNCTION GETS THE DEBIT JOURNAL, SORTS AND FILTERS IT TO A MORE DIGESTABLE FORMAT TO BE USED
 * @param {Object} debitAccount REQUIRED - this is the raw debit account information from the wirecard endpoint
*/
export const getHistory = (debitAccount) => {
  var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  return new Promise((resolve, reject) => {
    (async () => {
      const list = debitAccount?.data?.journal
      try {
        if (list && list.length) {
          const _list = list.map(item => {
            /* CREATE DATE OBJECT FROM STRING DATE */
            var d = new Date(item.transactionDate)
            /* GET STRING MONTH */
            var m = months[d.getMonth()]
            /* GET YEAR */
            const year = d.getFullYear()
            /* SET HISTORY INTO DIGESTABLE FORMAT */
            return {
              amount: item.transactionAmount,
              type: item.transactionType,
              dateRaw: d,
              date: d.toDateString(),
              month: m,
              year: year
            }
          })
          const temp = lodash.groupBy(_list, 'year')
          let data = []
          const keys = Object.keys(temp)
          /* SORT BY YEAR */
          keys.sort((a, b) => b - a)
          const promises = keys.map(async k => {
            const _temp = temp[k]
            /* SORT BY MONTH */
            _temp.sort((a, b) => {
              const _a = a.dateRaw.getMonth()
              const _b = b.dateRaw.getMonth()
              return _b - _a
            })
            /* FILTER LIST BY MONTH */
            const d = await arrayFilter(_temp, 'title', 'month', 'data')
            data = [...data, ...d]
          })
          await Promise.all(promises)
          resolve(data)
        } else {
          reject(new Error('No Transaction History Found'))
        }
      } catch (error) {
        reject(error)
      }
    })()
  })
}

export const transactionHistoryList = debitAccount => {
  const list = debitAccount?.data?.journal
  return list
}

const z = '{"balance":{"balanceAvailable":"17300","balanceDate":"2020-09-04T14:31:58.885Z","balanceLedger":"17300","balancePending":"0"},"card":{"accountStatus":"active","cardNumber":"5445XXXXXXXX8850","createdDate":"2018-06-06T15:30:23.723Z","expiration":"3/2021","lastPlasticDate":"2020-09-04T14:31:58.885Z","programId":"4512","puid":"A00005654"},"journal":[{"transactionAmount":"-300","transactionDate":"2020-07-01T03:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2020-05-01T03:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2020-04-01T03:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2020-03-01T04:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2020-02-01T04:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2020-01-01T04:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2019-12-01T04:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2019-11-01T03:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"-300","transactionDate":"2019-10-01T03:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"5000","transactionDate":"2019-06-07T14:54:04.883Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Receive $"},{"transactionAmount":"5000","transactionDate":"2019-06-07T14:49:01.977Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Receive $"},{"transactionAmount":"5000","transactionDate":"2019-06-07T13:46:36.263Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Receive $"},{"transactionAmount":"5000","transactionDate":"2019-06-06T19:33:06.810Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Receive $"},{"transactionAmount":"-100","transactionDate":"2019-06-01T03:59:59.000Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Fee"},{"transactionAmount":"100","transactionDate":"2019-01-31T20:17:33.833Z","transactionDetails":"XXXX","transactionFee":"0","transactionType":"Receive $"}],"response":{"code":"0","message":"OK"}}'
export const testData = JSON.parse(z)
